import React from 'react';
import DownloadIcon from './Download';
import InstagramIcon from './Instagram';
import YoutubeIcon from './Youtube';
import PinterestIcon from './Pinterest';
import FacebookIcon from './Facebook';
import LinkedinIcon from './Linkedin';
import HammerIcon from './Hammer';
import DoorIcon from './Door';
import LocationIcon from './Location';
import HeartIcon from './Heart';
import HouseIcon from './House';
import PriceIcon from './Price';
import OpenHamburgerIcon from './hamburger/Open';
import CloseHamburgerIcon from './hamburger/Close';
import FingerprintIcon from './Fingerprint';
import GroupIcon from './Group';
import PaletteIcon from './Palette';
import ChatIcon from './Chat';
import RightArrowIcon from './RightArrow';
import LeftArrowIcon from './LeftArrow';
import QuoteIcon from './Quote';
import RestartArrowIcon from './RestartArrow';
import ChevronIcon from './Chevron';
import PlayButtonIcon from './PlayButton';
import CircleIcon from './Circle';
import PauseIcon from './Pause';
import PlayIcon from './Play';
import CloseIcon from './hamburger/Close';
import ThreeDIcon from './ThreeD';
import StatesIcon from './States';
import CompassIcon from './Compass';
import LeaveIcon from './Leave';
import SearchIcon from './Search';
import InfoFillIcon from './Info-Fill';
import InfoIcon from './Info';
import BedIcon from './Bed';
import StoriesIcon from './Stories';
import ExteriorIcon from './Exterior';
import AreaIcon from './Area';
import SortIcon from './Sort';
import CalendarIcon from './Calendar';
import TrophyIcon from './Trophy';
import CameraIcon from './Camera';
import FilterIcon from './Filter';
import LocationSelectedIcon from './LocationSelected';
import OneIcon from './OneIcon';
import TwoIcon from './TwoIcon';
import TenIcon from './TenIcon';
import SunIcon from './Sun';
import BookIcon from './Book';
import QuillIcon from './Quill';
import ServiceIcon from './Service';
import MortgageIcon from './Mortgage';
import PaintIcon from './Paint';
import HomePlansIcon from './HomePlans';
import LayoutIcon from './Layout';
import KeyIcon from './Key';
import PercentIcon from './Percent';
import SwatchesIcon from './Swatches';
import PaperclipIcon from './Paperclip';
import WorkerIcon from './Worker';
import FlagIcon from './Flag';
import FhaIcon from './Fha';
import UsIcon from './Us';
import LensIcon from './Lens';
import SaveIcon from './Save';
import MapIcon from './MapIcon';
import ZoomIn from './ZoomIn';
import ZoomOut from './ZoomOut';

export enum EIcons {
  // SOCIALS
  FACEBOOK = 'facebook',
  YOUTUBE = 'youtube',
  PINTEREST = 'pinterest',
  LINKEDIN = 'linkedin',
  INSTAGRAM = 'instagram',

  // ACTIONS
  DOWNLOAD = 'download',
  RIGHT_ARROW = 'right-arrow',
  LEFT_ARROW = 'left-arrow',
  RESTART_ARROW = 'restart-arrow',
  PLAY_BUTTON = 'play_button',
  PAUSE = 'pause',
  PLAY = 'play',
  LEAVE = 'leave',
  SEARCH = 'search',
  SORT = 'sort',
  FILTER = 'filter',

  //  UI
  CHAT = 'chat',
  CHEVRON = 'chevron',
  QUOTE = 'quote',
  CIRCLE = 'circle',
  CLOSE = 'close',

  //INFOGRAPHIC
  DOOR = 'door',
  LOCATION = 'location',
  LOCATION_SELECTED = 'location_selected',
  HEART = 'heart',
  HOUSE = 'house',
  PRICE = 'price',
  FINGERPRINT = 'fingerprint',
  GROUP = 'group',
  HAMMER = 'hammer',
  PALETTE = 'palette',
  STATES = 'state',
  THREED = 'threeD',
  COMPASS = 'compass',
  INFO_FILL = 'info_fill',
  INFO = 'info',
  BED = 'bed',
  STORIES = 'stories',
  EXTERIOR = 'exterior',
  AREA = 'area',
  CALENDAR = 'calendar',
  TROPHY = 'trophy',
  CAMERA = 'camera',
  WARRANTY_ONE = 'warranty-one',
  WARRANTY_TWO = 'warranty-two',
  WARRANTY_TEN = 'warranty-ten',
  SUN = 'sun',
  BOOK = 'book',
  QUILL = 'quill',
  SERVICE = 'service',
  MORTGAGE = 'mortgage',
  PAINT = 'paint',
  HOME_PLANS = 'home-plans',
  LAYOUT = 'layout',
  KEY = 'key',
  PERCENT = 'percent',
  SWATCHES = 'swatches',
  PAPERCLIP = 'paperclip',
  WORKER = 'worker',
  FLAG = 'flag',
  FHA = 'fha',
  US = 'us',
  LENS = 'lens',
  SAVE = 'save',
  MAP_ICON = 'map',

  // NAV
  NAV_OPEN = 'nav_open',
  NAV_CLOSE = 'nav_close',

  ZOOM_IN = 'zoom_in',
  ZOOM_OUT = 'zoom_out',
}

export interface IconProps {
  color?: string;
  customClasses?: string;
}

type IconMapping = {
  [Key in EIcons]: React.ComponentType<IconProps>;
};

export const allIcons: IconMapping = {
  [EIcons.FACEBOOK]: FacebookIcon,
  [EIcons.YOUTUBE]: YoutubeIcon,
  [EIcons.PINTEREST]: PinterestIcon,
  [EIcons.LINKEDIN]: LinkedinIcon,
  [EIcons.INSTAGRAM]: InstagramIcon,
  [EIcons.DOWNLOAD]: DownloadIcon,
  [EIcons.FINGERPRINT]: FingerprintIcon,
  [EIcons.GROUP]: GroupIcon,
  [EIcons.HAMMER]: HammerIcon,
  [EIcons.PALETTE]: PaletteIcon,
  [EIcons.DOOR]: DoorIcon,
  [EIcons.LOCATION]: LocationIcon,
  [EIcons.HEART]: HeartIcon,
  [EIcons.HOUSE]: HouseIcon,
  [EIcons.PRICE]: PriceIcon,
  [EIcons.NAV_CLOSE]: CloseHamburgerIcon,
  [EIcons.NAV_OPEN]: OpenHamburgerIcon,
  [EIcons.CHAT]: ChatIcon,
  [EIcons.RIGHT_ARROW]: RightArrowIcon,
  [EIcons.LEFT_ARROW]: LeftArrowIcon,
  [EIcons.QUOTE]: QuoteIcon,
  [EIcons.RESTART_ARROW]: RestartArrowIcon,
  [EIcons.CHEVRON]: ChevronIcon,
  [EIcons.PLAY_BUTTON]: PlayButtonIcon,
  [EIcons.CIRCLE]: CircleIcon,
  [EIcons.PAUSE]: PauseIcon,
  [EIcons.PLAY]: PlayIcon,
  [EIcons.CLOSE]: CloseIcon,
  [EIcons.THREED]: ThreeDIcon,
  [EIcons.STATES]: StatesIcon,
  [EIcons.COMPASS]: CompassIcon,
  [EIcons.LEAVE]: LeaveIcon,
  [EIcons.SEARCH]: SearchIcon,
  [EIcons.INFO_FILL]: InfoFillIcon,
  [EIcons.INFO]: InfoIcon,
  [EIcons.BED]: BedIcon,
  [EIcons.STORIES]: StoriesIcon,
  [EIcons.EXTERIOR]: ExteriorIcon,
  [EIcons.AREA]: AreaIcon,
  [EIcons.SORT]: SortIcon,
  [EIcons.CALENDAR]: CalendarIcon,
  [EIcons.TROPHY]: TrophyIcon,
  [EIcons.CAMERA]: CameraIcon,
  [EIcons.FILTER]: FilterIcon,
  [EIcons.LOCATION_SELECTED]: LocationSelectedIcon,
  [EIcons.WARRANTY_ONE]: OneIcon,
  [EIcons.WARRANTY_TWO]: TwoIcon,
  [EIcons.WARRANTY_TEN]: TenIcon,
  [EIcons.SUN]: SunIcon,
  [EIcons.BOOK]: BookIcon,
  [EIcons.QUILL]: QuillIcon,
  [EIcons.SERVICE]: ServiceIcon,
  [EIcons.MORTGAGE]: MortgageIcon,
  [EIcons.PAINT]: PaintIcon,
  [EIcons.HOME_PLANS]: HomePlansIcon,
  [EIcons.LAYOUT]: LayoutIcon,
  [EIcons.KEY]: KeyIcon,
  [EIcons.PERCENT]: PercentIcon,
  [EIcons.SWATCHES]: SwatchesIcon,
  [EIcons.PAPERCLIP]: PaperclipIcon,
  [EIcons.WORKER]: WorkerIcon,
  [EIcons.FLAG]: FlagIcon,
  [EIcons.FHA]: FhaIcon,
  [EIcons.US]: UsIcon,
  [EIcons.LENS]: LensIcon,
  [EIcons.SAVE]: SaveIcon,
  [EIcons.MAP_ICON]: MapIcon,
  [EIcons.ZOOM_IN]: ZoomIn,
  [EIcons.ZOOM_OUT]: ZoomOut,
};
